export const WIDGET_LEARNING_LEADERBOARD_TYPE = 'learning-leaderboard';
